import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Paginator } from "../../models/formModel";

export interface DetailProjectUnitsState {
  loading: boolean;
  error: string | null;
  data: any[];
  paginator: Paginator | null;
}

const initialState: DetailProjectUnitsState = {
  loading: false,
  error: null,
  data: [],
  paginator: null,
};

const detailProjectUnitsSlice = createSlice({
  name: "detailProjectUnits",
  initialState,
  reducers: {
    fetchDetailProjectUnitsStart(state) {
      state.loading = true;
      state.error = null;
    },
    fetchDetailProjectUnitsSuccess(state, action: PayloadAction<{ items: any[]; meta: Paginator }>) {
      state.loading = false;
      state.data = action.payload.items;
      state.paginator = action.payload.meta;
    },
    fetchDetailProjectUnitsError(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
    clearDetailProjectUnits(state) {
      state.data = [];
      state.error = null;
      state.loading = false;
      state.paginator = null;
    }
  },
});

export const {
  fetchDetailProjectUnitsStart,
  fetchDetailProjectUnitsSuccess,
  fetchDetailProjectUnitsError,
  clearDetailProjectUnits,
} = detailProjectUnitsSlice.actions;

export default detailProjectUnitsSlice.reducer;
